import React, { memo, useEffect, useState } from 'react'
import Refund from './Refund'
import Modal from 'react-modal'
import { useSelector } from 'react-redux'
import moment from 'moment'
import ConfirmModal from '../../ComfirmModal'
import { formatNumberInput, removeSpaces } from '../../../helpers/formatNumber'
import api from '../../../api'
import { get } from 'lodash'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '900px',
	},
}

const RefundModal = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	currencyRate,
	isLoading,
}) => {
	const { getMe } = useSelector((state) => state.main)

	const employeeID = getMe?.EmployeeID

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [accountsData, setAccountsData] = useState([])
	const [form, setForm] = useState({
		DocDate: moment().format('YYYY-MM-DD'),
		Type: 'UsdToUzs',
		CashSumUzs: '',
		CashSumUsd: '',
	})
	const [stateCurrencyRate, setStateCurrencyRate] = useState(currencyRate)
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')

	useEffect(() => {
		const ref = {
			open: () => setIsOpenModal(true),
			close: () => setIsOpenModal(false),
			clear: () =>
				setForm({
					DocDate: moment().format('YYYY-MM-DD'),
					Type: 'UsdToUzs',
					CashSumUzs: '',
					CashSumUsd: '',
				}),
		}
		getRef(ref)
	}, [])

	useEffect(() => {
		api
			.get(
				`ChartOfAccounts?$filter=U_User eq ${employeeID} or U_User2 eq ${employeeID}&$select=Code,Name,AcctCurrency,U_User,U_User2`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				setAccountsData(JSON.parse(res.data).value)
			})
			.catch((err) => {
				console.log(err)
			})
	}, [])

	const handleOpenModal = () => {
		setConfirmationMessage([
			{
				name: 'Дата:',
				value: form.DocDate,
			},
			{
				name: 'Наличная сумма uzs:',
				value: !!form.CashSumUzs ? form.CashSumUzs : 0,
			},
			{
				name: 'Наличная сумма usd:',
				value: !!form.CashSumUsd ? form.CashSumUsd : 0,
			},
			{
				name: 'Со cчет:',
				value: form.numberCard1,
			},
			{
				name: 'На счет:',
				value: form.numberCard2,
			},
		])
		setShowModal(true)
	}

	const handleTypeChange = (e) => {
		const newType = e.target.value

		setForm((prevState) => {
			if (newType === 'UsdToUzs') {
				const usdValue =
					removeSpaces(prevState.CashSumUsd) ||
					(removeSpaces(prevState.CashSumUzs) / stateCurrencyRate).toFixed(2)
				return {
					...prevState,
					Type: newType,
					CashSumUsd: usdValue,
					CashSumUzs: (usdValue * stateCurrencyRate).toFixed(2),
					numberCard1: '',
					numberCard2: '',
				}
			} else {
				const uzsValue =
					removeSpaces(prevState.CashSumUzs) ||
					(removeSpaces(prevState.CashSumUsd) * stateCurrencyRate).toFixed(2)
				return {
					...prevState,
					Type: newType,
					CashSumUzs: uzsValue,
					CashSumUsd: (uzsValue / stateCurrencyRate).toFixed(2),
					numberCard1: '',
					numberCard2: '',
				}
			}
		})
	}

	const handleSumChange = (e) => {
		const value = removeSpaces(e.target.value)
		setForm((prevState) => {
			if (prevState.Type === 'UsdToUzs') {
				return {
					...prevState,
					CashSumUsd: value,
					CashSumUzs: (value * stateCurrencyRate).toFixed(2),
				}
			} else {
				return {
					...prevState,
					CashSumUzs: value,
					CashSumUsd: (value / stateCurrencyRate).toFixed(2),
				}
			}
		})
	}

	const schot1List = accountsData?.filter((v) =>
		form?.Type === 'UsdToUzs'
			? v?.AcctCurrency === 'USD'
			: v?.AcctCurrency === 'UZS',
	)

	const schot2List = accountsData?.filter((v) =>
		form?.Type === 'UsdToUzs'
			? v?.AcctCurrency === 'UZS'
			: v?.AcctCurrency === 'USD',
	)

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => {
				setIsOpenModal(false)
				setShowModal(false)
				setForm({
					DocDate: moment().format('YYYY-MM-DD'),
					Type: 'UsdToUzs',
					CashSumUzs: '',
					CashSumUsd: '',
				})
			}}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<Refund>
				<div className="w-full p-[50px]">
					<h2 className={'text-center mb-5'}>{'Сдача деньги'}</h2>
					<div className="flex flex-col  gap-5 mb-10">
						<div className="flex items-center gap-2 w-full justify-between">
							<input
								type="date"
								placeholder="Date"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								value={form.DocDate}
								onChange={(v) =>
									setForm((prevState) => ({
										...prevState,
										DocDate: v.target.value,
									}))
								}
							/>
							<input
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								defaultValue={stateCurrencyRate}
								onChange={(v) => setStateCurrencyRate(v.target.value)}
							/>
						</div>

						<div className="flex items-center gap-2 w-full">
							<input
								type="text"
								placeholder="Cумма"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								value={formatNumberInput(
									form.Type === 'UsdToUzs' ? form.CashSumUsd : form.CashSumUzs,
								)}
								onChange={handleSumChange}
							/>

							<select
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-[150px]'
								}
								value={form.Type}
								onChange={handleTypeChange}
							>
								<option value="UsdToUzs">{'USD'}</option>
								<option value="UzsToUsd">{'UZS'}</option>
							</select>
							<div className="relative w-full">
								<input
									type="text"
									list="schot1"
									placeholder={'Со счета'}
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
									}
									value={form.numberCard1}
									onChange={(v) =>
										setForm((prevState) => ({
											...prevState,
											numberCard1: v.target.value,
										}))
									}
								/>
								<datalist id="schot1">
									{schot1List?.map((v, i) => (
										<option
											key={i}
											label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
											value={get(v, 'Code', '')}
											selected={get(v, 'Code', '') === form.numberCard1}
										/>
									))}
								</datalist>
							</div>
						</div>

						<div className="flex items-center gap-2 w-full">
							<input
								type="text"
								placeholder="Другая валюта"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								disabled
								value={
									form.Type === 'UsdToUzs'
										? formatNumberInput(removeSpaces(form.CashSumUzs)) + ' UZS'
										: formatNumberInput(removeSpaces(form.CashSumUsd)) + ' USD'
								}
							/>
							<div className="relative w-full">
								<input
									type="text"
									list="productName2"
									placeholder={'На счет'}
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1 w-full'
									}
									value={form.numberCard2}
									onChange={(v) => {
										setForm((prevState) => ({
											...prevState,
											numberCard2: v.target.value,
										}))
									}}
								/>
								<datalist id="productName2">
									{schot2List?.map((v, i) => (
										<option
											key={i}
											label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
											value={get(v, 'Code', '')}
											selected={get(v, 'Code', '') === form.numberCard2}
										/>
									))}
								</datalist>
							</div>
						</div>
					</div>
					<div className="centerCard">
						<button
							className="btnN"
							onClick={() => {
								onClose()
								setForm({
									DocDate: moment().format('YYYY-MM-DD'),
									Type: 'UsdToUzs',
									CashSumUzs: '',
									CashSumUsd: '',
								})
							}}
						>
							{'Нет'}
						</button>
						<button
							className="btnY disabled:cursor-not-allowed disabled:bg-gray-300 hover:bg-green-600 hover:text-white border-[4px] border-green-600 disabled:border-gray-300 disabled:border-gray-300"
							disabled={
								form.DocDate === '' ||
								form.Type === '' ||
								form.CashSumUzs === '' ||
								form.CashSumUsd === '' ||
								form.numberCard1 === '' ||
								form.numberCard2 === '' ||
								isLoading
							}
							onClick={() => {
								handleOpenModal()
							}}
						>
							{'Да'}
						</button>
					</div>
				</div>
				<ConfirmModal
					show={showModal}
					data={confirmationMessage}
					onConfirm={() => {
						setShowModal(false)
						onConfirm(form)
					}}
					onCancel={() => {
						setShowModal(false)
					}}
				/>
			</Refund>
		</Modal>
	)
}

export default memo(RefundModal)
